import { Box, CircularProgress } from '@mui/material';

function ProgressLoader({ loading }) {

  return (
    loading ? <Box
      sx={{
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
      }}
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgcolor="rgba(0,0,0,0.4)"
      zIndex={1000}
    >
      <CircularProgress size={64} disableShrink thickness={3} sx={{ color: '#44EB8D' }} />
    </Box> : null
  );
}

export default ProgressLoader;